$dotBorderRadius: 0;

.ux-dot-pagination {
  box-sizing: border-box;
  display: block;
  margin: 0 auto;

  &__container,
  &__inner {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
  }

  &__container {
    padding: 20px 10px;
  }

  &__inner {
    padding: 0 10px;
  }

  &__arrow {
    cursor: pointer;
    transition: opacity 200ms ease-in-out;

    &--prev {
      transform: rotate(180deg);
    }

    &--disabled {
      opacity: 0.25;
      pointer-events: none;
    }
  }

  &__item {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 16px;
    justify-content: center;
    transition: all 200ms ease-out;
    width: 16px;

    &--hidden {
      height: 0;
      opacity: 0;
      pointer-events: none;
      transform: scale(0);
      width: 0;
    }

    &--small {
      transform: scale(0.85);
    }
  }

  &__dot {
    background-color: $color-black;
    border-radius: $dotBorderRadius;
    display: block;
    height: 8px;
    opacity: 0.2;
    pointer-events: none;
    transition: all 200ms ease-out;
    vertical-align: middle;
    width: 8px;

    &:focus-visible {
      outline: 1px solid $color-black;
    }

    .ux-dot-pagination__item--active & {
      background-color: $color-green;
      height: 12px;
      opacity: 1;
      width: 12px;
    }
  }
}
